import React, { useEffect } from 'react';
import { Box, Button, IconButton, Stack, Typography } from '@mui/material';
import NotificationCard from './NotificationCard';
import { Close } from '@mui/icons-material';
import { deleteNotifyByIdServ, deleteNotifyByUserServ, getNotifyByUserServ } from '../../../services/notify-service';
import { useAuthContext } from '../../../context/AuthContext';
import QueryKey from '../../../utils/QueryKey';
import { useQuery, useQueryClient } from 'react-query';
import { isNotEmpty } from '../../../utils/format';
import { customAlert } from '../../../components/notify';
import ScrollBox from '../../../components/ScrollBox';


function NotificationPage({ handleClose, }) {
  const queryClient = useQueryClient();
  const {  ctxtUser, setAsyncLoading } = useAuthContext();
  const { isLoading, isError, error, data: nData } = useQuery([QueryKey.notify, ctxtUser.userId], () => getNotifyByUserServ(),
    {
      enabled: isNotEmpty(ctxtUser?.userId),
      refetchOnMount: true,
      refetchOnWindowFocus: false,
    });

  useEffect(() => {
    setAsyncLoading(isLoading);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoading]);

  async function handleClearAll() {
    setAsyncLoading(true);
    try {
      await deleteNotifyByUserServ();
      queryClient.invalidateQueries();
      handleClose();
    } catch (error) {
      console.log(error)
      customAlert(error)
    }
    setAsyncLoading(false);
  };

  async function handleClear(notifyId) {
    setAsyncLoading(true);
    try {
      await deleteNotifyByIdServ(notifyId);
      queryClient.invalidateQueries();
    } catch (error) {
      console.log(error)
      customAlert(error)
    }
    setAsyncLoading(false);
  };

  if (isError) {
    customAlert(error);
    return <h2>Something went wrong</h2>
  }

  return (
    <Stack sx={{ height: "100vh", width: "60vw", alignItems: "center", justifyContent: "center", p: 1 }}>
      <Box sx={{ borderColor: 'rgb(0,0,0,0.4)', borderRadius: 2, border: 0.2, py: 1, width: "100%", mx: 'auto', height: "100%" }}>
        <Stack direction={"row"} alignItems={"center"} justifyContent={"space-between"} px={3}>
          <Stack width={"20%"} alignItems={"start"}>
            <IconButton onClick={() => handleClose()}>
              <Close />
            </IconButton>
          </Stack>

          <Stack width={"50%"} alignItems={"center"}>
            <Typography sx={{ fontSize: 18 }}> Notifications </Typography>
          </Stack>

          <Stack width={"20%"} alignItems={"end"}>
            <Button onClick={handleClearAll} sx={{
              color: 'error.main', cursor: 'pointer', border: 'none', background: 'none', fontSize: 16,
              '&:hover': { textDecoration: 'underline' }
            }}>Clear All</Button>
          </Stack>
        </Stack>
        <ScrollBox height={"94%"}>
          {(nData?.notifyArr ?? []).map((i) => <NotificationCard key={i?.id} i={i} handleClear={handleClear} />)}
        </ScrollBox>
      </Box>
    </Stack>
  );
}

export default NotificationPage;